/**
 * Création et initialisation de la variable _numeral_ avec la localisation fr
 * @category Utils
 */
var numeral = require("numeral"); // Chargement de la locale française


try {
  numeral.register("locale", "fr", {
    delimiters: {
      thousands: " ",
      decimal: ","
    },
    abbreviations: {
      thousand: "k",
      million: "m",
      billion: "b",
      trillion: "t"
    },
    ordinal: function ordinal(number) {
      return number === 1 ? "er" : "ème";
    },
    currency: {
      symbol: "€"
    }
  });
} catch (error) {// console.log(error);
} // Définition de la locale française


numeral.locale("fr");
/**
 * Renvoi un nombre aléatoire entre 0 et 1 000 000
 * @category Utils
 */

export function generateId() {
  return Math.floor(Math.random() * 999999);
}
export { numeral };